import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AuthCard } from '../components/AuthCard';
import { Alert } from '../components/Alert';
import { api } from '../lib/api';

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [state, setState] = useState<'pending' | 'ok' | 'error'>('pending');
  // StrictMode monte deux fois : sans cette garde, le second POST partait
  // pendant que le premier consommait le token, et « expiré » gagnait l'écran.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    if (!token) {
      setState('error');
      return;
    }
    api
      .post('/auth/verify-email', { token })
      .then(() => setState('ok'))
      .catch(() => setState('error'));
  }, [token]);

  return (
    <AuthCard title="Vérification de l'adresse e-mail">
      {state === 'pending' ? <p className="subtitle">Vérification en cours…</p> : null}
      {state === 'ok' ? (
        <Alert message="Votre adresse e-mail est confirmée." variant="success" />
      ) : null}
      {state === 'error' ? <Alert message="Ce lien est invalide ou a expiré." /> : null}
      <Link className="btn btn-secondary" to="/login">
        Aller à la connexion
      </Link>
    </AuthCard>
  );
}
